import React, { useMemo, useState } from 'react';
import * as PropTypes from 'prop-types';
import Input from './Input';

const InputPassword = React.forwardRef((props, ref) => {
    const { name } = props;

    const [typeInput, setTypeInput] = useState('password');
    const showOrNotPassword = () => {
        if (typeInput === 'password') {
            setTypeInput('text');
        } else {
            setTypeInput('password');
        }
    };

    const renduBoutonAction = useMemo(() => {
        return (
            <>
                <div
                    style={{
                        float: 'right',
                        marginBottom: '0.5rem',
                    }}
                >
                    <div className="fr-checkbox-group fr-checkbox-group--sm">
                        <input
                            type="checkbox"
                            id={`${name}-afficher`}
                            name={`${name}-afficher`}
                            onClick={showOrNotPassword}
                            checked={typeInput === 'text'}
                        />
                        <label className="fr-label" htmlFor={`${name}-afficher`}>
                            Afficher
                        </label>
                    </div>
                </div>
            </>
        );
    }, [typeInput, setTypeInput]);

    return <Input {...props} type={typeInput} boutonAction={renduBoutonAction} ref={ref} />;
});

InputPassword.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.oneOfType([
        PropTypes.shape({
            message: PropTypes.string,
        }),
        PropTypes.bool,
    ]),
    texteAide: PropTypes.string,
};

InputPassword.defaultProps = {
    name: null,
    label: null,
    error: null,
    texteAide: null,
};

export default InputPassword;
